import type {Money} from '../money/typedef';

/**
 * @description Create Money object from amount and currency
 * @param {Money|number=} amount - amount of money
 * @param {string} currency - money currency
 * @return {string} - Money object
 * @example
 * //returns {amount: 3, currency: 'USD'}
 * amountToMoney(3, 'USD');
 */
export const amountToMoney = (
    amount: Money | number | undefined,
    currency: string,
): Money | undefined => {
    if (typeof amount === 'number') {
        return {
            amount,
            currency,
        };
    }

    return amount;
};
